import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProvisionInfoDataForm.html?raw';
import '../../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import '../../../moreCore/UI/SearchSelect/SearchSelect';

class ProvisionInfoDataForm extends compose(_WidgetBaseSP) {
    templateString: any = template;
    isReadonly: boolean = false;
    isDirty: boolean = false;

    ProvisionInput: MdsLax<InstanceType<typeof SearchSelect>>;

    formData: any = {
    };
    originalData: string = "";

    loadFormData(data: IndividualData_ProvisionInfo): void {

        //####
        this.ProvisionInput.loadListValues(data.ID);

        //####

        this.serializeFormData();

        this.originalData = JSON.stringify(this.formData);
        console.debug(this.originalData);
    }

    serializeFormData(): void {

        //####


        //####

        console.debug("SERIALIZE DATA:", this.formData);
        this.checkDirty();
        console.debug("isDirty:", this.isDirty);
    }

    _onClick_saveBtn(): void {

        if (this.isDirty) {

            //save API post
            alert("SAVING FUNCTION!");
        }
    }

    checkDirty(): void {

        this.isDirty = JSON.stringify(this.formData) !== this.originalData;

        this.emit("change_isDirty", this.isDirty);
    }

    _onChangeProvisionInput(): void {

        this.serializeFormData();
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProvisionInfoDataForm);